// extracted by mini-css-extract-plugin
export var brand = "_93-9";
export var compact = "_93-6";
export var extraSmall = "_93-7";
export var icon = "_93-0";
export var large = "_93-4";
export var light = "_93-1";
export var medium = "_93-5";
export var outline = "_93-b";
export var primaryDark = "_93-a";
export var primaryLight = "_93-8";
export var primaryModern = "_93-c";
export var success = "_93-2";
export var successSolid = "_93-3";